export enum AccessType {
    NONE = 'NONE',
    READ_ONLY = 'READ_ONLY',
    READ_WRITE = 'READ_WRITE',
}